export default "__VITE_ASSET__3f2651ae__"